import styled from "styled-components";

const ItemContainer = styled.div`
  padding: .16rem .24rem;
  background-color: #fff;
  margin-top: .16rem;
`;

const TitleComtainer = styled.div`
  font-size: 0.28rem;
  color: #262626;
  line-height: .44rem;
`;
const DetailContainer = styled.div`
  font-size: 0.24rem;
  color: #8C8C8C;
  line-height: .4rem;
`;

export { ItemContainer, TitleComtainer, DetailContainer };
